import { IMessage } from '../../types/IMessage';
import { IAudience } from '../../types/User/IAudience';
import { IMessageConfig } from '../../types/User/IMessageConfig';
import { Api } from './BaseApi'

const MessageApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getAudience: build.query<IAudience[], number>({
            query: (id: number) => `Message/${id}/audience`,
            providesTags: ["GetMyMessages"],
        }),
        getMessages: build.query<IMessage[], void>({
            query: () => `Message/My`,
            providesTags: ["GetMyMessages"],
        }),
        getConfig: build.query<IMessageConfig, void>({
            query: () => `Message/Config`,
            providesTags: ["GetMyMessages"],
        }),
        createMessage: build.mutation<void, { text: string, expires: Date, important: boolean, startdt: Date | null, visibility: IAudience[] }>({
            query: (content) => ({
                url: `Message`,
                method: "POST",
                body: {
                    Expire_Dt: content.expires,
                    Created_By_Name: "",
                    Id: 0,
                    Important: content.important,
                    Is_Read: false,
                    Profile_Image_Link: "",
                    Start_Dt: content.startdt ?? new Date().toISOString(),
                    Text: content.text,
                    MessageSecurity: content.visibility
                }
            }),
            invalidatesTags: ["GetMyMessages"],
        }),
        readMessage: build.mutation<void, number>({
            query: (id: number) => ({
                url: `Message/${id}/read`,
                method: "POST",
            }),
            invalidatesTags: ["GetMyMessages"],
        }),
        deleteMessage: build.mutation<void, number>({
            query: (id: number) => ({
                url: `Message/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["GetMyMessages"]
        }),
        closeMessage: build.mutation<void, number>({
            query: (id: number) => ({
                url: `Message/${id}/close`,
                method: "POST"
            }),
            invalidatesTags: ["GetMyMessages"]
        }),
    }),
    overrideExisting: false,
})

export { MessageApi };